<div class="ir-area ir-header th-header">
  <div class="ir-line th-header-line">
    <div class="ir-line--left">
      <img src="/Content/svg/client-logo.svg" class="ir-logo" />
    </div>
    <div class="ir-line--right">
      <div class="ir-btn th-btn-normal" (click)="logout()">
        <i class="material-icons">power_settings_new</i>
      </div>
    </div>
    <div class="ir-line-content">
      <span>{{ 'unauthorized.unauthorized' | translate }}</span>
    </div>
  </div>
</div>
<div class="ir-area ir-body th-body">
  <div class="ir-content-fixed ir-mv2 th-content">
    <p class="th-txt">
      <span innerHtml="{{ 'unauthorized.no-permissions' | translate }}"></span>
    </p>
  </div>
</div>
